export default "__VITE_ASSET__8ef46243__"